import React, { useState, useContext } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import RseeTimePicker from '../../../../components/timePicker';
import 'rc-time-picker/assets/index.css';

import AddCafeContext from '../AddOrEditCafeContext';
import ENUMS from '../../../../enums';
import { dataGenerator } from '../../../../utils';

const AddOrEditWorkingHourModal = props => {
  console.log('editMode', props);
  const [day, setWeekDay] = useState(props.editMode ? props.day : 'SAT');
  const [fromTime, setFromTime] = useState(props.editMode ? props.fromTime : '06:00');
  const [toTime, setToTime] = useState(props.editMode ? props.toTime : '00:00');

  const [dayInvalidMessage, setDayInvalidMessage] = useState('');
  const [dayInputValidateStatus, setDayInputValidateStatus] = useState('');

  const cafeContext = useContext(AddCafeContext);

  const onChangeWeekDay = event => {
    const dayValue = event.target.value;
    setWeekDay(dayValue);
  };

  const validateModalForm = () => {
    let isWeekDayValid = true;
    let isDuplicate = false;

    if (props.editMode) {
      isDuplicate = !props.isWorkingHourItemDuplicate({ day, fromTime, toTime });
    } else {
      isDuplicate = !props.isWorkingHourItemDuplicate({ day, fromTime, toTime });
    }

    if (!day) {
      isWeekDayValid = false;
      setDayInvalidMessage(locales('messages.fieldValueIsDuplicate', { fieldName: locales('fields.week.day') }));
      setDayInputValidateStatus('');
    } else {
      setDayInvalidMessage(locales('messages.fieldValueIsDuplicate', { fieldName: locales('fields.week.day') }));
      setDayInputValidateStatus('');
    }

    // return isWeekDayValid && !!isDuplicate;
    return true; // TODO
  };

  const saveFormData = () => {
    console.log('save form data');
    const isFormValid = validateModalForm(props.editMode);

    if (!isFormValid) {
      return;
    }

    if (props.editMode === true) {
      const workingHourObject = {
        itemKey: props.itemKey,
        day,
        fromTime,
        toTime
      };
      console.log('workingHourObject', workingHourObject);
      cafeContext.editWorkingHourItem(workingHourObject);
    } else {
      const workingHourObject = {
        itemKey: dataGenerator.generateKey('working_hour'),
        day,
        fromTime,
        toTime
      };
      console.log('workingHourObject', workingHourObject);
      cafeContext.addWorkingHourItem(workingHourObject);
    }

    props.closeModal();
  };

  const cancel = () => {
    props.closeModal();
  };

  const onChangeFromTime = selectedTime => {
    setFromTime(selectedTime);
  };

  // const onChangeToTime = momentObj => {
  //   console.log('momentObj', momentObj);
  //   setToTime(momentObj.format('HH:mm'));
  // };

  const onChangeToTime = selectedTime => {
    setToTime(selectedTime);
  };

  return (
    <Modal isOpen={props.isOpen}>
      <ModalHeader>
        {props.editMode ? locales('titles.edit.working.hour') : locales('titles.add.new.working.hour')}
      </ModalHeader>
      <ModalBody>
        <form className="form-horizontal">
          <div className="form-row">
            <div className="form-group col d-flex required">
              <label htmlFor="day" className="rsee-form-label">
                {locales('fields.week.day')}
              </label>
              <div className="full-width">
                <select
                  id="day"
                  className={`form-control ${dayInputValidateStatus}`}
                  value={day}
                  onChange={onChangeWeekDay}
                >
                  {ENUMS.WEEK_DAYS.list.map((x, ix) => (
                    <option value={x.value} key={x.value}>
                      {x.title}
                    </option>
                  ))}
                </select>
                <div className="invalid-feedback">{dayInvalidMessage}</div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col d-flex required">
              <label htmlFor="fromTime" className="rsee-form-label">
                {locales('fields.start.time')}
              </label>
              <div className="full-width" dir="ltr">
                {/* <TimePicker showSecond={false} onChange={onChangeFromTime} value={momentJalaali(fromTime, 'HH:mm')} /> */}
                <RseeTimePicker onChange={onChangeFromTime} value={fromTime} format="HH:mm" />
              </div>
            </div>

            <div className="form-group col d-flex required">
              <label htmlFor="toTime" className="rsee-form-label">
                {locales('fields.end.time')}
              </label>
              <div className="full-width">
                {/* <TimePicker showSecond={false} onChange={onChangeToTime} value={momentJalaali(toTime, 'HH:mm')} /> */}
                <RseeTimePicker onChange={onChangeToTime} value={toTime} format="HH:mm" />
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button onClick={saveFormData} type="button" className="btn btn-success">
          {props.editMode ? locales('labels.do.edit') : locales('labels.do.add')}
        </button>
        <button type="button" className="btn" onClick={cancel}>
          {locales('labels.cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AddOrEditWorkingHourModal;
